export default {
  USER_SEARCH_GET_REQUEST: "USER_SEARCH_GET_REQUEST",
  USER_SEARCH_GET_RECEIVE: "USER_SEARCH_GET_RECEIVE",
  USER_SEARCH_GET_ERROR: "USER_SEARCH_GET_ERROR",
  USER_SEARCH_RESET: "USER_SEARCH_RESET"
};
